import React, { FC } from "react";
import { UsersListItemDto } from "@green0meter/api-client";

import Table from "./components/Table";
import TableToolbar from "./components/TableToolbar";
// import UserRolesTabs from "./components/UserRolesTabs";
import UserEditor from "./components/UserEditor";
import BlockUserConfirmation from "./components/BlockUserConfirmation";

import { Stack } from "@components/base";

interface UsersManagement {
  handleCreateUser: () => void;
  companyNameFilter: string;
  handleCopanyNameFilter: (query: string) => void;
  companyIdFilter: string;
  handleCopanyIdFilter: (query: string) => void;
  editUser?: UsersListItemDto;
  handleEditUser: (user: UsersListItemDto) => void;
  userEditorOpen: boolean;
  handleCloseUserEditor: () => void;
  handleBlockUser: (user: UsersListItemDto) => void;
  cancelBlockUser: () => void;
  blockUserConfirmation?: UsersListItemDto;
}

const UsersManagement: FC<UsersManagement> = ({
  handleCreateUser,
  companyNameFilter,
  handleCopanyNameFilter,
  companyIdFilter,
  handleCopanyIdFilter,
  editUser,
  handleEditUser,
  userEditorOpen,
  handleCloseUserEditor,
  handleBlockUser,
  cancelBlockUser,
  blockUserConfirmation,
}) => (
  <>
    <Stack spacing={3} mt={3}>
      <TableToolbar
        onCreateUserButtonClick={handleCreateUser}
        companyNameFilter={companyNameFilter}
        onCompanyNameFilterChange={handleCopanyNameFilter}
        companyIdFilter={companyIdFilter}
        onCompanyIdFilterChange={handleCopanyIdFilter}
      />
      <Table
        onUserEdit={handleEditUser}
        onBlockUser={handleBlockUser}
        companyNameFilter={companyNameFilter}
        companyIdFilter={companyIdFilter}
      />
    </Stack>
    <UserEditor
      open={userEditorOpen}
      user={editUser}
      onClose={handleCloseUserEditor}
    />
    {blockUserConfirmation && (
      <BlockUserConfirmation
        user={blockUserConfirmation}
        onCancel={cancelBlockUser}
      />
    )}
  </>
);

export default UsersManagement;
